export const contentMarginToOpen: number = 270;
export const contentMarginToClose: number = 75;
export const step: number = 0;
export const duration: number = 2000;
export const fileName: string = 'users_lists.xlsx';
export const exportFileName: string = 'Master Store List(' + new Date().toLocaleString('en-US', { month: 'short' }) + ' ' + new Date().getDate() + ' ' + new Date().getFullYear() + ').xlsx';
//paginator
export const pageIndex: number = 1;
export const pageSize: number = 50;
export const graphPageSize: number = 10;
export const totalCount: number = 0;
export const from: number = 0;
export const to: number = 0;
export const page: number[] = [50, 100, 200, 500];
export const graphPage: number[] = [10, 20, 50, 100];
export const masterAdminRoleId: number = 1;
export const role: string = 'master';
export const adminListRoleId: number[] = [2, 3];
export const regionalAdminRoleId: number[] = [4, 5];
export const countryPICRoleId: number = 6;
export const noDataFound: string = 'No Data Found';
export const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
export const elxColor = '#011E41'
export const othersColor = '#D0B993'
export const siemensColor = '#00A9A2'
export const hitachiColor = '#CC0000'
export const hisenseColor = '#05D0C8'
export const sharpColor = '#D00000'
export const toshibaColor = '#E61E1E'
export const aegColor = '#CF122E'
export const zanussiColor = '#FEE800'
export const vintecColor = '#96172E'
export const kelvinatorColor = '#004683'
export const mideaColor = '#1F94D2'
export const samsungColor = '#024EA6'
export const fkColor = '#0073CC'
export const haierColor = '#0C5CA8'
export const boschColor = '#E0000A'
export const lgColor = '#C4084F'
export const mieleColor = '#8C0014'
export const glemgasColor = '#CD1719'
export const westinghouseColor = '#2962F2'
export const frigidairehouseColor = '#8F1838'


// MAXIMUM NOTIFICATION TO SHOW
export const maxNotification = 5;
